export default "__VITE_ASSET__9c017984__"